export default function ({queryArgs}) {
  const newQueryArgs = {...queryArgs}
  delete newQueryArgs.toastSuccessMessageStatus
  delete newQueryArgs.toastErrorMessageStatus
  return newQueryArgs
}
